import React, {useState} from "react";

import pingItApi from "../../api/pingItApi";

import '../style/details.css';

const validateIP = (ip) => {
    const regex = new RegExp(/^(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/);
    return regex.test(ip);
}

const IpInput = () => {

    const [label, setLable] = useState(<span className="fixed-span" style={{color: '#FFBF00'}}>Non valido</span>);
    const [ipList, setIpList] = useState([]);

    const [isValid, setValid] = useState(false);

    const getIpList = () => {
        pingItApi.get("/hosts/checkip", {withCredentials: true}).then((res) => {
            setIpList(res.data);
        })
    }

    const isAlreadyPresent = (ip) => {
        if(ipList.some(host => host.host.trim() === ip.trim())){
            setValid(false);
            return true;
        }
        setValid(true);
        return false;
    };

    const labelHandler = (ip) => {
        if(!validateIP(ip)) return setLable(<span className="fixed-span" style={{color: '#FFBF00'}}>Non valido</span>);
        if(isAlreadyPresent(ip)) return setLable(<span className="fixed-span" style={{color: '#DC143C'}}>Già presente</span>);
        return setLable(<span className="fixed-span" style={{color: '#50C878'}}>Valido</span>);
    }

    return ([
        <input onFocus={() => getIpList()} onChange={(e) => labelHandler(e.target.value)} style={{width: '95%'}} type="text" name="host_ip" id="host_ip" data-valid={isValid} />,
        <label htmlFor="host_ip">{label}</label>
    ])
}

export default IpInput;